import {makeStyles, Theme} from '@material-ui/core/styles'

export const useStickyClasses = makeStyles(
  (theme: Theme) => ({
    root: {
      zIndex: 1,
      background: '#fff',
      boxShadow: 'none',
    },
    sticky: {
      position: 'sticky',
      bottom: -1,
      borderTopLeftRadius: theme.spacing(3),
      borderTopRightRadius: theme.spacing(3),
      transition: 'box-shadow .3s ease-in-out',
    },
    isSticky: {
      boxShadow: '0 -4px 20px rgb(117 115 111 / 20%)',
      [theme.breakpoints.down('sm')]: {
        borderTopLeftRadius: theme.spacing(3),
        borderTopRightRadius: theme.spacing(3),
      },
    },
  }),
  {name: 'StickyGrid'},
)
